import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var ReservedPostException = /*#__PURE__*/function (_Error) {
  function ReservedPostException(post_id) {
    var _this;
    _classCallCheck(this, ReservedPostException);
    _this = _callSuper(this, ReservedPostException, ["".concat(post_id, " is reserved")]);
    _defineProperty(_this, "name", "ReservedPostException");
    _defineProperty(_this, "post_id", null);
    _this.post_id = post_id;
    return _this;
  }
  _inherits(ReservedPostException, _Error);
  return _createClass(ReservedPostException);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { ReservedPostException as default };